<script>
  // @ts-check
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Bullet from "../components/Bullet.svelte";
  import Bullets from "../components/Bullets.svelte";
  import CTAs from "../components/CTAs.svelte";
  import H1 from "../components/H1.svelte";
  import P from "../components/P.svelte";
  import LicenseChip from "../components/LicenseChip.svelte";
  import Slide from "../components/Slide.svelte";

  import { getIconProps, style } from "../utils";
  const license = "outreach";
  const iconProps = getIconProps(license);
</script>

<Slide>
  <LicenseChip {style} {license} />
  <H1>The tools you need. All in one place</H1>
  <P>
    Recruiters don’t need more admin – they need results. From first touch to
    final placement, SourceWhale is the recruitment productivity platform that
    handles every step.
  </P>
  <Bullets>
    <Bullet>
      <IconScale class="fa-chart-mixed" {...iconProps} />Track outreach ROI in
      real-time
    </Bullet>
    <Bullet>
      <IconScale class="fa-list-check" {...iconProps} />
      Manage your entire funnel</Bullet
    >
    <Bullet>
      <IconScale class="fa-trophy" {...iconProps} />
      See how your team is performing</Bullet
    >
  </Bullets>
  <CTAs tourLink="https://sourcewhale.navattic.com/b7h0895" />
</Slide>
